import { useCallback, useState } from 'react';

export default function useSourAlert() {
	const [alertProps, setAlertProps] = useState({ isOpen: false });

	const handleClose = useCallback(() =>
		setAlertProps(prev => ({ ...prev, isOpen: false })), []);

	const showAlert = useCallback((config) =>
		setAlertProps({ isOpen: true, onClose: handleClose, ...config }), [handleClose]);

	return [alertProps, showAlert];
}
